import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PricingLimitTemplate.Delete.IRequest;
type Response = Api.Core.PricingLimitTemplate.Delete.IResponse;
type Headers = Api.Core.PricingLimitTemplate.Delete.IHeaders;
const url = '/api/ProductManagement/PricingLimitTemplate/:id';
export default async function pricingLimitTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
